<div class="dashboard-container">
  <globot-statistics></globot-statistics>
</div>
